<template>
  <div
    class="autocomplete"
    @keydown.enter="enter"
    @keydown.down="down"
    @keydown.up="up"
  >
    <slot name="input" :onInput="onInput" :inputValue="inputValue">
      <div class="form-group">
        <input
          type="text"
          class="form-control"
          autocomplete="off"
          v-model="inputValue"
          :placeholder="placeHolderValue"
        />
      </div>
    </slot>
    <ul v-if="openSuggestion" class="autocomplete-list list-group">
      <li
        class="list-group-item"
        v-for="(item, index) in suggestions"
        :active="isActive(index)"
        @click="suggestionClick(index)"
        :key="item[optionField]"
      >
        <slot name="list-item" :item="item">
          {{ item[optionField] }}
        </slot>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "autocomplete",
  props: {
    list: {
      required: true,
    },
    minimumChars: {
      type: Number,
      default: 1,
    },
    optionField: String,
    editFillValue: String,
    placeHolderValue: String,
    resetField: Boolean,
  },
  data: () => ({
    open: false,
    current: 0,
    inputValue: "",
    suggestionClicked: false,
  }),
  methods: {
    onInput(value) {
      if (!value) return;

      this.inputValue = value;

      if (!this.suggestionClicked) {
        if (this.open === false) {
          this.open = true;
          this.current = 0;

          return;
        }
      } else {
        this.suggestionClicked = false;
      }

      if (this.current > this.suggestions.length - 1) {
        this.current = 0;
      }
    },
    up() {
      if (this.current > 0) {
        this.current--;
      }
    },
    down() {
      if (this.current < this.suggestions.length - 1) {
        this.current++;
      }
    },
    isActive(index) {
      return index === this.current;
    },
    suggestionClick(index) {
      this.open = false;
      this.suggestionClicked = true;

      this.$emit("input", this.suggestions[index]);

      this.inputValue = this.suggestions[index][this.optionField];
    },
    enter() {
      this.open = false;

      this.inputValue = "";

      this.$emit("input", this.suggestions[this.current]);
    },
  },
  watch: {
    inputValue(value) {
      this.onInput(value);
    },
    editFillValue(value) {
      this.suggestionClicked = true;
      this.inputValue = value;
    },
    resetField() {
      this.inputValue = "";
    },
  },
  computed: {
    openSuggestion() {
      return (
        this.inputValue.length >= this.minimumChars &&
        this.suggestions.length > 0 &&
        this.open === true
      );
    },
    suggestions() {
      return this.list.filter((item) =>
        item[this.optionField]
          .toUpperCase()
          .includes(this.inputValue.toUpperCase())
      );
    },
  },
};
</script>

<style scoped>
.autocomplete-list {
  position: absolute;
  width: 100%;
  max-height: 300px;
  overflow-y: scroll;
  z-index: 10;
}
</style>



// WEBPACK FOOTER //
// src/components/common/ProductMenuGroupTemplate.vue